import { environment } from '../../../../environments/environment'
import { type CartoClient } from './carto.helper'

export interface DeliveryRow {
  start: string
  finish: string
  granularity: string
  territory: string
  type: string
  name: string
  id: number
  config: string
  default_config: string
  childs: number[]
  parent: number
}

export async function fetchDeliveries(
  cartoClient: CartoClient,
  signal?: AbortSignal,
): Promise<DeliveryRow[]> {
  const response = await cartoClient.query<DeliveryRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_deliveries`,
    },
    params: {
      column: [
        'start',
        'finish',
        'granularity',
        'territory',
        'type',
        'name',
        'id',
        'config',
        'default_config',
        'childs',
        'parent',
      ],
    },
    signal,
  })

  return response?.rows ?? []
}
